import React, { useState } from "react";
import FilterBar from "./filterBar";
import MotionFilters from "./motionFilters";

const Header = ({
  search,
  setSearch,
  setFilterValue,
  filterValue,
  FilterMenu,
  handleBtnClick,
  btnLabel,
  placeholder,
  handleUploadBtn,
  customerCreditLimit,
  importExcelBtnLabel,
  handleImportExcel,
  btnIcon,
  nameOfPage,
  alwaysShowFilter,
  pageName,
  minDate,
  ...rest
}) => {
  const [motionFilters, setMotionFilters] = useState(false);
  const onFilterClick = () => {
    setMotionFilters(!motionFilters);
  };
  return (
    <div>
      <FilterBar
        search={search}
        FilterMenu={FilterMenu}
        setSearch={setSearch}
        placeholder={placeholder}
        setFilterValue={setFilterValue}
        alwaysShowFilter={alwaysShowFilter}
        filterValue={filterValue}
        onFilterClick={onFilterClick}
        motionFilters={motionFilters}
        handleBtnClick={handleBtnClick}
        btnLabel={btnLabel}
        handleUploadBtn={handleUploadBtn}
        importExcelBtnLabel={importExcelBtnLabel}
        handleImportExcel={handleImportExcel}
        customerCreditLimit={customerCreditLimit}
        btnIcon={btnIcon}
        nameOfPage={nameOfPage}
        pageName={pageName}
        minDate={minDate}
      />

      {(motionFilters || alwaysShowFilter) && (
        <MotionFilters
          motionFilters={motionFilters || alwaysShowFilter}
          FilterMenu={FilterMenu}
          setFilterValue={setFilterValue}
          filterValue={filterValue}
          {...rest}
        />
      )}
    </div>
  );
};
export default Header;
